import React from "react";
import {Table, Col, Divider} from "antd";
import {useTranslation} from "react-i18next";
import {propductTablePropType} from "./ProductTablePropTypes";
import {paymentTypes} from "../../../constants/constants";

const ProductTable = (props: propductTablePropType) => {
    const {
        showPaymentInfo = false,
        price = "0",
        paymentType = "",
        showBarcode = false,
        barcode = undefined
    } = props;
    const {t} = useTranslation(["paymentTypes"]);
    //#region views
    return (
        <>
            <Table
                rowKey="_id"
                dataSource={props.dataSource}
                pagination={Boolean(props.pagination)}
                data-testid="productTable"
            >
                <Table.Column
                    dataIndex="productName"
                    title={t("fields.productName", {ns: "common"})}
                    render={text => <span data-testid="productName">{text}</span>}
                />
                <Table.Column
                    dataIndex="ingredients"
                    title={t("fields.productContent", {ns: "common"})}
                    render={text => <span data-testid="ingredients">{text}</span>}
                />
                <Table.Column
                    dataIndex="amount"
                    title={t("fields.productAmount", {ns: "common"})}
                    render={text => <span data-testid="amount">{text}</span>}
                />
            </Table>
            {props.showNote && (
                <Col span={24}>
                    <Divider orientation="left">{t("fields.orderNote", {ns: "common"})}</Divider>
                    <p
                        data-testid="deliveryNote"
                        style={{
                            marginLeft: 40,
                            marginRight: 40
                        }}
                    >
                        {props.note}
                    </p>
                </Col>
            )}
            {showPaymentInfo && (
                <Col span={24}>
                    <Divider orientation="left">{t("fields.paymentInfo", {ns: "common"})}</Divider>
                    <p
                        data-testid="paymentInfo"
                        style={{
                            marginLeft: 40,
                            marginRight: 40
                        }}
                    >
                        <b>{`${price || "0"}₺ `}</b>(
                        {t(paymentTypes.find(pT => pT.value == paymentType)?.translation_key, {
                            ns: "paymentTypes"
                        }) || t("unknown", {ns: "paymentTypes"})}
                        )
                    </p>
                </Col>
            )}
            {showBarcode && barcode && (
                <Col span={24}>
                    <Divider orientation="left">{t("fields.barcode", {ns: "common"})}</Divider>
                    <p
                        data-testid="orderBarcode"
                        style={{
                            marginLeft: 40,
                            marginRight: 40
                        }}
                    >
                        {barcode}
                    </p>
                </Col>
            )}
        </>
    );
    //#endregion
};

export default ProductTable;
